module.exports = __webpack_public_path__ + "static/img/shopping-cart.f53417be.png";